// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39daaf5e","455":"8ae0e9fb","698":"98f50179","946":"2899ea17"}[chunkId] + ".chunk.js";
};